import { render, staticRenderFns } from "./PaymentDate.vue?vue&type=template&id=2135c956&"
import script from "./PaymentDate.vue?vue&type=script&lang=js&"
export * from "./PaymentDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports